import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateToPlainFormat } from '@/utils'
import { UserExternalCollaborationStatus } from '@/types'

export interface ExternalCollaboration {
  externalId: string
  externalPassword: string
  registrationDate: string
  registrationBranchCode: SystemCode
  status: UserExternalCollaborationStatus
}

export const defaultExternalCollaboration = (): ExternalCollaboration => ({
  externalId: '',
  externalPassword: '',
  registrationDate: '',
  registrationBranchCode: defaultSystemCode(),
  status: UserExternalCollaborationStatus.Unused
})

export function ExternalCollaborationFromJSON(
  json: any
): ExternalCollaboration {
  return {
    externalId: exists(json, 'external_id') ? json.external_id : '',
    externalPassword: exists(json, 'external_password')
      ? json.external_password
      : '',
    registrationDate: exists(json, 'registration_date')
      ? dateToPlainFormat(json.registration_date)
      : '',
    registrationBranchCode: exists(json, 'registration_branch_code')
      ? SystemCodeFromJSON(json.registration_branch_code)
      : defaultSystemCode(),
    status: exists(json, 'status')
      ? json.status
      : UserExternalCollaborationStatus.Unused
  }
}
